import axios from "@/app/Axios"

class sables {

    async listadotacionsable() {
        try {
            const startTime = performance.now();
            const response = await axios.get("/dotacionsablepersonal")
            const endTime = performance.now();
            const elapsedTime = endTime - startTime;
            //return response.data
            if (response && response.data) {
                console.log("Estos son mis datos", response);
                console.log(`La solicitud tardó ${elapsedTime} milisegundos.`);
                return {
                    status: true,
                    records: response.data.data
                };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return {
                    status: false,
                    records: []
                };
            }
        } catch (error) {
            //console.log(error);
            if (error.response && error.response.status === 401) {
                return {
                    status: false,
                    message: error.response.data.message
                };
            } else {
                console.log(error);
                return {
                    status: false,
                    message: "Error interno del servidor"
                };
            }
        }
    }
    async saveSable(cuchillopost) {
        try {
            const response = await axios.post("/sabledotacionpost", cuchillopost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async actualizarDotacionSable(datosActualizar) {
        try {
            const url = `/sabledotacionput/${datosActualizar.codigo_dotacion}`;
            const response = await axios.put(url, datosActualizar);
            return response.data;
        } catch (error) {
            console.error("Error al actualizar la dotación de cuchillo:", error);
            throw error;
        }
    }
    async deleteRegistroSable(id) {
        try {
            const response = await axios.delete(`/sabledotaciondelete/${id}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
}

export default sables